import $ from "jquery";
import "@@assets/scripts/_$.addImageRatioInfo";

$(() => {
	
	const $block = $('.new-posts-slider');
	if(!$block.length) {
		return false;
	}
	
	// スマホのみ
	if(window.app.device[0] === "pc") {
		return false;
	}
	const $entryList = $block.children(".entry-list");
	const $wrapSlide = $block.find(".wrap-entry-item");
	if(!$wrapSlide.length) {
		return false;
	}
		
	$wrapSlide.children(".entry-item").each((i, elm) => {
		$(elm).clone(true).appendTo($entryList);
	});
		
	$wrapSlide.remove();
		
		
	$block.find(".slides").each((i, elm) => {
		const $slides = $(elm);
		$slides.find("img").addImageRatioInfo(!!$slides.children().length && (() => {

			$slides.slick({
				fade: false,
				autoplay: true,
				dots: true,
				arrows: false,
				speed: 600,
				adaptiveHeight: true,
				pauseOnFocus: false,
				cssEase: "linear",
				lazyLoad: "anticipated",
			});
		}));
	});
	
});
